import { Navigate } from 'react-router-dom'
import { useAuthContext } from '../context/AuthContext'
import LoadingSpinner from './LoadingSpinner'

export default function PublicOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuthContext()

  if (user) {
    return <Navigate to="/dashboard" replace />
  }

  if (loading) {
    return <LoadingSpinner />
  }

  return <>{children}</>
}
